const d3 = require('d3');

d3.select('body').append('div').attr('id', 'toolTip');

const makeHorizontalBarChart = function (elementId, data, {
	onClick,
	chartMethod = {},
	x = d => d, // given d in data, returns the (quantitative) y-value
	y = (d, i) => i, // given d in data, returns the (ordinal) x-value
	marginTop = 20, // the top margin, in pixels
	marginRight = 20, // the right margin, in pixels
	marginBottom = 0, // the bottom margin, in pixels
	marginLeft = 0, // the left margin, in pixels
	width = 640, // the outer width of the chart, in pixels
	height, // the outer height of the chart, in pixels
	xDomain, // [ymin, ymax]
	xSupDomain = [], // an array of x-values
	xSupDomainTranslate = [], // an array of x-values translate
	xRange = [marginLeft, width - marginRight], // [left, right]
	xType = d3.scaleLinear, // x-scale type
	xFormat, // a format specifier string for the x-axis
	yDomain, // an array of (ordinal) y-values
	yRange = [height - marginBottom, marginTop], // [top, bottom]
	yPadding = 0.1, // amount of y-range to reserve to separate bars
	rectFormatLabel = item => `${item.toLocaleString()}`, // a format specifier string for the rect label
	yLabel, // a label for the y-axis
	xLabel, // a label for the x-axis
	fillColor = 'currentColor', // bar fill color
	legendColor = () => {
	}, // bar fill color
} = {}) {

	function removeChart() {
		d3.select(`#${elementId} svg`).remove();
	}

	removeChart();

	function wrapText(text, width) {
		text.each(function () {
			const text = d3.select(this);
			const words = text.text().split(/\s+/).reverse();
			let word;
			let line = [];
			const lineHeight = 1.1; // ems
			const y = text.attr('y');
			const dy = parseFloat(text.attr('dy'));
			let tspan = text.text(null).append('tspan').attr('x', -9).attr('y', y).attr('dy', `${dy}em`);

			// eslint-disable-next-line no-cond-assign
			while (word = words.pop()) {
				line.push(word)
				tspan.text(line.join(' '))
				if (tspan.node().getComputedTextLength() > width) {
					if (line.join(' ') === word) {
						continue;
					}
					line.pop()

					tspan.text(line.join(' '))
					line = [word]
					tspan = text.append('tspan').attr('x', -9).attr('y', y).attr('dy', `${lineHeight + dy}em`).text(word);
				}
			}

		})
	}

	if (!(elementId in chartMethod)) {
		chartMethod[elementId] = {};
	}
	const xLabelHeight = yLabel ? 105 : 0;
	xRange[0] += xLabelHeight;

	const yLabelHeight = xLabel ? 30 : 0;
	yRange[0] -= yLabelHeight;

	// Compute values.
	const X = d3.map(data, x);
	const Y = d3.map(data, y).flat();
	if (xDomain === undefined) xDomain = [0, d3.max(X)];
	if (yDomain === undefined) yDomain = Y;
	yDomain = new d3.InternSet(yDomain);

	// Omit any data not present in the x-domain.
	// const I = d3.range(X.length).filter(i => yDomain.has(Y[i]));

	// Compute the default height.
	if (height === undefined) height = Math.ceil((yDomain.size + yPadding) * 25) + marginTop + marginBottom;
	if (yRange === undefined) yRange = [marginTop, height - marginBottom];


	// Construct scales, axes, and formats.
	const xScale = xType(xDomain, xRange);
	const yScale = d3.scaleBand(yDomain, yRange).padding(yPadding);
	const xAxis = d3.axisTop(xScale).tickFormat(xFormat);
	const yAxis = d3.axisLeft(yScale).tickSizeOuter(0);
	// console.log({
	// 	X, x, xDomain, xRange, xAxis, Y, y, yDomain, yRange, yAxis, w: yScale.bandwidth(),
	// })


	const svg = d3.select(`#${elementId}`)
		.append('svg')
		.attr('width', width)
		.attr('height', height)
		.attr('viewBox', [0, 0, width, height])
		.style('direction', 'ltr')
		.style('max-width', '100%')
		.style('height', 'auto')

	let selectedItem = null;
	const click = function (d, i) {
		if (!onClick) return;

		const type = i?.data?.type || i?.type || '';
		const clearFilters = (!!selectedItem && selectedItem === type);

		onClick?.(i?.data || i, clearFilters);

		if (clearFilters) {
			chartMethod[elementId]?.resetHighlight();
			selectedItem = null;
			return;
		}

		selectedItem = type;
		svg.selectAll('.original').style('opacity', 0.5);
		svg.selectAll(`.original.${type}`).style('opacity', 1);
	};

	const foreign = svg.append('foreignObject')
		.attr('width', width)
		.attr('height', height)
		.append('xhtml:div')
		.style('display', 'flex')
		.style('justify-content', 'center')
		.style('flex-wrap', 'wrap');

	foreign.selectAll('g.items').data(xSupDomain)
		.enter()
		.append('div')
		.attr('class', 'item')
		.style('display', 'flex')
		.style('align-items', 'center')
		.style('margin', '0 10px')
		.each(function (d, i) {
			const g = d3.select(this)
			const rectSize = 15
			g.append('div')
				.attr('style', () => `background-color:${legendColor(d, i)};width:${rectSize}px;height:${rectSize}px;margin-right:5px`);
			g.append('div')
				.text(() => xSupDomainTranslate[i] || xSupDomain[i]);
		})


	svg.append('g')
		// محل قرارگیری درجه های عمودی: 0 که با بارها لب به لب شوند و مارجین بالا و ارتفاع لیبل که رو هم قرار نگیرند
		.attr('transform', `translate(0,${marginTop + yLabelHeight})`)
		.call(xAxis)
		.attr('font-family', '')
		.call(g => g.select('.domain').remove())
		.call(g => g.selectAll('.tick line').clone()
			.attr('x2', 0)
			.attr('y2', height - marginTop - marginBottom - yLabelHeight)
			.attr('stroke-opacity', 0.1))


	svg.append('text')
		.attr('x', width / 2)
		.attr('y', yLabelHeight - marginTop)
		.attr('fill', 'currentColor')
		.attr('text-anchor', 'start')
		.text(xLabel);

	const bar = svg.append('g')
		.selectAll('g')
		.attr('class', 'chart')
		.data(data)
		.join('g')
		.attr('transform', d => `translate(0, ${yScale(y(d))})`) // چینش بارها در زیرهم با فاصله ثابت و برابر
		.selectAll('rect')
		.data((d, i) => {
			if (xSupDomain?.length > 0) {
				const normalizeData = xSupDomain.map((key, index) => ({
					key,
					value: d[key],
					data: d,
					index,
				}))

				return normalizeData
			}

			return [{
				key: d,
				value: x(d),
				data: d,
				index: i,
			}];
		})
		.join('rect')
		.attr('fill', (d) => fillColor(d.data, d.index))
		.attr('x', xScale(0)) // استارت بارها از خط صفر
		.attr('y', marginTop + yLabelHeight - 20) // استارت لب به لب بارها با محور عمودی و زیر لیبل های عمودی
		.attr('class', (d) => `original ${d.data?.type || ''}`)
		.attr('height', yScale.bandwidth()) // ضخامت هر bar
		.attr('width', d => {
			if (d3.max(X) === 0) {
				return 0;
			}

			return xScale(d.value) - xLabelHeight;
		})
		.on('click', click)
		.on('mouseover', (e, d) => {
			d3.select('#toolTip')
				.style('left', `${e.pageX}px`)
				.style('top', `${e.pageY}px`)
				.style('opacity', 1)
				.style('position', 'absolute')
				.style('background-color', '#404040')
				.style('color', 'white')
				.style('border-radius', '8px')
				.style('padding', '4px 8px')
				.style('font-size', '14px')
				.text(() => rectFormatLabel(d));
		})
		.on('mouseout', () => {
			d3.select('#toolTip')
				.style('opacity', 0);
		})

	chartMethod[elementId].removeChart = removeChart;
	// chartMethod[elementId].addHighlight = function (data) {
	// 	svg.selectAll('.original')
	// 		.style('opacity', 0.5);
	//
	// 	const Y1 = d3.map(data, y);
	// 	const yFilterDomain = [0, d3.max(Y1)]
	// 	const yFilterScale = yType(yFilterDomain, yRange);
	// 	// const X1 = d3.map(data, x);
	// 	// const xFilterDomain = [0, d3.max(X1)]
	// 	// const xFilterScale = xType(xFilterDomain, yRange);
	//
	// 	svg.append('g')
	// 		.attr('class', 'highlighted')
	// 		.selectAll('rect')
	// 		.data(I)
	// 		.join('rect')
	// 		.attr('fill', (d, i) => fillColor(d.data, i))
	// 		.attr('x', i => xScale(X[i]))
	// 		.attr('y', i => yFilterScale(Y1[i]))
	// 		.attr('height', i => yFilterScale(0) - yFilterScale(Y1[i]))
	// 		// .attr('x', i => xScale(X[i]))
	// 		// .attr('y', i => xFilterScale(X1[i]))
	// 		// .attr('height', i => xFilterScale(0) - xFilterScale(X1[i]))
	// 		// .attr('width', xScale.bandwidth());
	// }
	chartMethod[elementId].resetHighlight = function () {
		// chartMethod[elementId]?.removeHighlight();
		svg.selectAll('.original').style('opacity', 1);
	}
	// chartMethod[elementId].removeHighlight = function () {
	// 	svg.selectAll('g.highlighted').remove();
	// }

	svg.append('g')
		.attr('transform', `translate(${marginLeft + xLabelHeight}, ${marginTop + yLabelHeight - 20})`) // محور اصلی عمودی (پر رنگه)
		.call(yAxis)
		.attr('font-family', '')
		.selectAll('.tick text')
		.call(wrapText, xLabelHeight - 35);

	svg.append('text')
		.attr('transform', 'rotate(-90)')
		.attr('y', marginLeft + 20)
		.attr('x', -(height / 2))
		.style('text-anchor', 'middle')
		.text(yLabel);

	return svg.node();
}

export default makeHorizontalBarChart;